import $ from 'jquery';
import passengerItem from "./passenger-item";

export default function (params) {

	let passengerAd = new passengerItem(params.ad),
		passengerYa = new passengerItem(params.ya),
		passengerCh = new passengerItem(params.ch),
		passengerInf = new passengerItem(params.inf),
		$total = $('.js_total-passenger .c-total-passenge__qt'),
		$msg = $('.js_total-passenger .c-total-passenge__msg');

	function controlAction(params) {

		let m = getQt();

		if (params.inpuId === '#ad') {

			if (params.type === 'incr' && m.summa < 9) {
				passengerAd.setQt(++m.ad);

			} else if (params.type === 'decr' && m.ad > 1) {
				if (m.inf === m.ad) {
					passengerInf.setQt(--m.inf);
				}
				passengerAd.setQt(--m.ad);
			}

		} else if (params.inpuId === '#ya') {

			if (params.type === 'incr' && m.summa < 9) {
				passengerYa.setQt(++m.ya);
			} else if (params.type === 'decr' && m.ya > 0) {
				passengerYa.setQt(--m.ya);
			}

		} else if (params.inpuId === '#ch') {

			if (params.type === 'incr' && m.summa < 9) {
				passengerCh.setQt(++m.ch);
			} else if (params.type === 'decr' && m.ch > 0) {
				passengerCh.setQt(--m.ch);
			}

		} else if (params.inpuId === '#inf') {

			if (params.type === 'incr' && m.summa < 9 && m.ad > m.inf) {
				passengerInf.setQt(++m.inf);
			} else if (params.type === 'decr' && m.inf > 0) {
				passengerInf.setQt(--m.inf);
			}
		}

		setTotal();
	}

	passengerAd.subscribeChange(controlAction);
	passengerYa.subscribeChange(controlAction);
	passengerCh.subscribeChange(controlAction);
	passengerInf.subscribeChange(controlAction);

	function getQt() {
		let ad = parseInt(passengerAd.getQt(), 10),
			ya = parseInt(passengerYa.getQt(), 10),
			ch = parseInt(passengerCh.getQt(), 10),
			inf = parseInt(passengerInf.getQt(), 10),
			summa = ad + ya + ch + inf;

		return {
			ad: ad,
			ya: ya,
			ch: ch,
			inf: inf,
			summa: summa
		}
	}


	function setTotal() {
		let m = getQt(),
			msg = 'пассажир';

		if (m.summa > 1 && 5 > m.summa) {
			msg+= 'а';
		} else if (m.summa > 4) {
			msg+= 'ов';
		}

		$total.text(m.summa);
		$msg.text(msg);
	}

	setTotal();
}


// WEBPACK FOOTER //
// ./widget/control-passenger.js